import React from "react"
import RegisterGoogleDetail from "../../../common/GoogleOriginalDesign/Hotelslabo/Detail/RegisterGoogleDetail"

export default function GoogleRegisterSapporo() {
    return (
        <RegisterGoogleDetail
            reasonPoint1Images={[
                {
                    src: "/pages/google/hotelslabo/register_sapporo/reason_point1_img1.png",
                    alt: "札幌の限定求人詳細1枚目",
                },
                {
                    src: "/pages/google/hotelslabo/register_sapporo/reason_point1_img2.png",
                    alt: "札幌の限定求人詳細2枚目",
                },
                {
                    src: "/pages/google/hotelslabo/register_sapporo/reason_point1_img3.png",
                    alt: "札幌の限定求人詳細3枚目",
                },
            ]}
            signupPath='signup?channel=hotel_googleadwords'
        />
    )
}
